import React from 'react';
import { 
    Box, 
    Button, 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    IconButton,
    CircularProgress,
} from '@mui/material';
import { Check as CheckIcon, Close as CloseIcon, Upload as UploadIcon, Save as SaveIcon } from '@mui/icons-material';
import { Field, reduxForm } from 'redux-form';
import { TableElement, CloseButton, DateRangeInput, SelectInput, TextInput, MultiSelectInput } from '../../_Components';

const EditDatabaseModal = ({ 
    isOpen, 
    onClose, 
    editingDatabase, 
    isSavingEdit,
    isCheckingDatabase,
    isLoadingDatabase,
    checkResult,
    onSaveEdit,
    onCheckDatabase,
    onLoadDatabase,
    formValues,
    queues,
    handleSubmit,
    submitting
}) => {
    if (!editingDatabase) return null;
    const handleFormSubmit = (formData) => {
        // Получаем данные из формы и передаем их обратно в родительский компонент
        onSaveEdit(formData);
    };

    const handleCheckClick = () => {
        // Получаем данные из формы и вызываем проверку
        handleSubmit((formData) => {
            onCheckDatabase(formData);
        })();
    };

    const handleLoadClick = () => {
        // Получаем данные из формы и вызываем загрузку
        handleSubmit((formData) => {
            onLoadDatabase(formData);
        })();
    };

    return (
        <Dialog 
            open={isOpen} 
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6">
                        Редактирование базы данных
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Box>
            </DialogTitle>
            
            <form onSubmit={handleSubmit(handleFormSubmit)}>
                <DialogContent>
                    <Box mt={2}>
                        {/* Форма редактирования */}
                        <Box>
                            <Typography variant="h6" gutterBottom>
                                Настройки базы данных
                            </Typography>
                            
                            <Box display="flex" flexDirection="column" gap={3}>
                                {/* Название базы данных */}
                                <Box>
                                    <Field
                                        name="name"
                                        label="Название *"
                                        disabled={false}
                                        placeholder="Введите название базы данных"
                                        component={TextInput}
                                    />
                                    {/* Карточка проекта */}
                                    <Field
                                        name="query_mongo.project"
                                        label="Карточка"
                                        disabled={false}
                                        options={formValues.cards ? formValues.cards.map(card => ({
                                            id: card._id,
                                            name: card.name
                                        })) : []}
                                        component={SelectInput}
                                    />
                                    {/* Очередь */}
                                    <Field
                                        name="queue"
                                        label="Очередь *"
                                        disabled={false}
                                        options={queues ? queues.filter(q => q.type === "Outbound").map(queue => ({
                                            id: queue.id,
                                            name: queue.name
                                        })) : []}
                                        component={SelectInput}
                                    />
                                </Box>
                                 {/* Телефоны */}
                                 <Box>
                                    <Field
                                        name="query_mongo.phones"
                                        label="Телефоны *"
                                        disabled={false}
                                        options={formValues.fields ? formValues.fields.map(field => ({
                                            id: field.value,
                                            name: field.label
                                        })) : []}
                                        placeholder="Введите название базы данных"
                                        component={MultiSelectInput}
                                    />
                                    {/*Период */}
                                    <Field
                                        name="query_mongo.created"
                                        label="Период *"
                                        disabled={false}
                                        options={formValues.cards ? formValues.cards.map(card => ({
                                            id: card._id,
                                            name: card.name
                                        })) : []}
                                        component={DateRangeInput}
                                    />
                                     {/*URL */}
                                     <Field
                                        name="url"
                                        label="Url *"
                                        disabled={false}
                                        component={TextInput}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                    
                    {/* Результат проверки */}
                    {checkResult && (
                        <Box mt={3}>
                            <Typography variant="h6" gutterBottom>
                                Результат проверки
                            </Typography>
                            {checkResult && checkResult.length > 0 ? (
                                <TableElement
                                    header={[
                                        { label: 'ID', value: 'id', width: 20 },
                                        { label: 'Телефон', value: 'phone', width: 80 }
                                    ]}
                                    rows={checkResult.map((row, index) => ({
                                        id: row._id || `row_${index}`,
                                        phone: row.phone || row.data?.phone || 'Не указан'
                                    }))}
                                    edit={false}
                                    remove={false}
                                />
                            ) : (
                                <Box textAlign="center" py={2}>
                                    <Typography variant="body2" color="textSecondary">
                                        Результаты проверки не найдены
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    )}
                </DialogContent>
                
                <DialogActions>

                    <CloseButton handleCloseClick={onClose}  disabled={isCheckingDatabase || isLoadingDatabase || isSavingEdit || submitting} label="Отмена"/>
                    {checkResult && (
                        <Button 
                            onClick={() => onCheckDatabase(null)} // Передаем null для очистки результата
                            variant="outlined" 
                            color="secondary"
                            size="small"
                        >
                            Очистить результат
                        </Button>
                    )}
                    <Button 
                        onClick={handleCheckClick}
                        variant="outlined" 
                        color="info"
                        disabled={isCheckingDatabase || submitting}
                        startIcon={isCheckingDatabase ? <CircularProgress size={20} /> : <CheckIcon />}
                    >
                        {isCheckingDatabase ? 'Проверка...' : 'Проверить'}
                    </Button>
                    <Button 
                        onClick={handleLoadClick}
                        variant="outlined" 
                        color="warning"
                        disabled={isLoadingDatabase || submitting}
                        startIcon={isLoadingDatabase ? <CircularProgress size={20} /> : <UploadIcon />}
                    >
                        {isLoadingDatabase ? 'Загрузка...' : 'Загрузить'}
                    </Button>
                    <Button 
                        type="submit"
                        variant="contained" 
                        color="primary"
                        disabled={isSavingEdit || submitting}
                        startIcon={isSavingEdit ? <CircularProgress size={20} /> : <SaveIcon />}
                    >
                        {isSavingEdit ? 'Сохранение...' : 'Сохранить'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

// Оборачиваем компонент в reduxForm
const EditDatabaseModalForm = reduxForm({
    form: 'editDatabaseForm',
    enableReinitialize: true, // Позволяет переинициализировать форму при изменении initialValues
    validate: (values) => {
        const errors = {};
        if (!values.name) {
            errors.name = 'Название обязательно для заполнения';
        }
        if (!values.project) {
            errors.project = 'Карточка проекта обязательна для выбора';
        }
        if (!values.queue) {
            errors.queue = 'Очередь обязательна для выбора';
        }
        return errors;
    }
})(EditDatabaseModal);

// Создаем HOC для правильной передачи initialValues
const EditDatabaseModalWithInitialValues = (props) => {
    const { editingDatabase, ...restProps } = props;
    
    // Создаем правильно отформатированные initialValues
    const initialValues = React.useMemo(() => {
        if (!editingDatabase) return {};
        
        const values = {
            _id: editingDatabase._id || null,
            url: editingDatabase.url || '',
            name: editingDatabase.name || '',
            project: editingDatabase.project || editingDatabase.projectId || '',
            queue: editingDatabase.queue || editingDatabase.queueId || '',
            query_mongo: {
                phones: editingDatabase.query_mongo?.phones || [],
                created: editingDatabase.query_mongo?.created || []
            }
        };
        

        return values;
    }, [editingDatabase]);
    
    return (
        <EditDatabaseModalForm
            {...restProps}
            editingDatabase={editingDatabase}
            initialValues={initialValues}
        />
    );
};

export default EditDatabaseModalWithInitialValues;
